import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ButtonComponent } from '@examdojo/core/button';
import { IconComponent } from '@examdojo/core/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { ExternalFilterType } from '../list-view.model';
import { ExternalFilterValue } from './list-view-external-filtering.model';
import { ListViewExternalFilteringDialogService } from './list-view-external-filtering-dialog/list-view-external-filtering-dialog.service';
import { ListViewExternalFilteringService } from './list-view-external-filtering.service';

@Component({
  selector: 'dojo-list-view-external-filtering',
  template: `
    <div class="button-wrap relative w-full md:w-auto">
      <dojo-button [fill]="'outline'" (click)="openDialog()" class="w-full md:w-auto">
        <dojo-icon [icon]="'sliders'" class="mr-2 text-neutral-400 dark:text-sky-400"></dojo-icon>
        <span>{{ 'assessment.popup.filters' | transloco }}</span>
      </dojo-button>
      @if (activeFiltersCount()) {
        <div
          class="border-neutral-0 text-neutral-0 aligner absolute right-[-7px] top-[-5px] h-6 min-w-6 rounded-full border-[2px] bg-sky-500 text-sm font-semibold"
        >
          {{ activeFiltersCount() }}
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, IconComponent, TranslocoPipe],
  providers: [ListViewExternalFilteringService],
})
export class ListViewExternalFilteringComponent {
  constructor(
    private readonly listViewExternalFilteringService: ListViewExternalFilteringService,
    private readonly listViewExternalFilteringDialogService: ListViewExternalFilteringDialogService,
  ) {}

  readonly form = this.listViewExternalFilteringService.formGroup;

  readonly filterColumns = this.listViewExternalFilteringService.filterColumns;

  readonly activeFiltersCount = signal<number>(0);

  readonly temporaryResetFormValue = signal<Record<string, ExternalFilterValue>>({});

  openDialog() {
    this.temporaryResetFormValue.set(this.form.value);
    this.listViewExternalFilteringDialogService.open(this.listViewExternalFilteringService).then((result) => {
      if (result !== true) {
        this.listViewExternalFilteringService.resetFilter(this.temporaryResetFormValue());
      }
      this.setFilterValuesCount();
    });
  }

  private setFilterValuesCount() {
    this.activeFiltersCount.set(
      this.filterColumns().reduce((acc, filterColumn) => {
        if (
          filterColumn.filter === ExternalFilterType.Checkbox &&
          Array.isArray(filterColumn.formCtrl.value) &&
          !!filterColumn.formCtrl.value.length
        ) {
          return acc + filterColumn.formCtrl.value.length;
        }
        if (filterColumn.filter === ExternalFilterType.Range) {
          return acc + (filterColumn.formCtrl.value ? 1 : 0);
        }
        return acc;
      }, 0),
    );
  }
}
